var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteClassic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.25C1.50119 12.6475 1.6596 13.0283 1.94065 13.3093C2.2217 13.5904 2.60254 13.7488 3 13.75H9C9.39746 13.7488 9.7783 13.5904 10.0593 13.3093C10.3404 13.0283 10.4988 12.6475 10.5 12.25V3.25H1.5V12.25ZM7.65 4.75H8.775V12.25H7.65V4.75ZM5.4 4.75H6.525V12.25H5.4V4.75ZM3.15 4.75H4.275V12.25H3.15V4.75ZM11.25 1V2.5H0.75V1H3.375L4.125 0.25H7.875L8.625 1H11.25Z",
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteClassic);
export default __webpack_public_path__ + "static/media/Delete_Classic.633a41cd7b4e35cef122afd5b934f279.svg";
export { ForwardRef as ReactComponent };